<template>
  <!-- 用法: this.$confirm.show('提示内容') 或 this.$confirm.show({ title, content, confirmText, cancelText }) -->
  <v-dialog
      v-model="visible"
      persistent
      max-width="400"
      @keydown.esc="cancel"
  >
    <v-card class="confirm-card">
      <v-card-title class="headline d-flex align-center">
        <v-icon color="warning" class="mr-2">mdi-alert-circle-outline</v-icon>
        {{ title }}
      </v-card-title>

      <v-card-text class="text-body-1 pt-2">{{ content }}</v-card-text>

      <v-card-actions class="px-4 pb-4">
        <v-spacer />
        <v-btn text @click="cancel">{{ cancelText }}</v-btn>
        <v-btn color="error" class="ml-2" @click="confirm">{{ confirmText }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  data() {
    return {
      visible: false,
      title: '提示',
      content: '',
      confirmText: '确定',
      cancelText: '取消',
      resolve: null
    }
  },
  methods: {
    // options: string | { title, content, confirmText, cancelText }
    show(options) {
      const opts = typeof options === 'string' ? { content: options } : (options || {})
      this.title = opts.title || '提示'
      this.content = opts.content || ''
      this.confirmText = opts.confirmText || '确定'
      this.cancelText = opts.cancelText || '取消'
      this.visible = true
      return new Promise(resolve => {
        this.resolve = resolve
      })
    },
    confirm() {
      this.visible = false
      this.resolve && this.resolve(true)
    },
    cancel() {
      this.visible = false
      this.resolve && this.resolve(false)
    }
  }
}
</script>

<style scoped>
.confirm-card {
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/ConfirmDialog/index.vue